import { useCallback } from "react";

// Meta service module
const useMetaService = (api) => {
  const getObjectMetadata = useCallback(
    async (moduleName) => {
      try {
        const response = await api.get(`/meta/${moduleName}`);
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error fetching object metadata:", error);
        throw error;
      }
    },
    [api]
  );

  const updateRecordMetadata = useCallback(
    async (id, name, columns) => {
      try {
        const response = await api.put(`/meta/${id}`, { id, name, columns });
        return response;
      } catch (error) {
        console.error("Error updating object metadata:", error);
        throw error;
      }
    },
    [api]
  );

  const addColumn = useCallback(
    async (metaId, name, dataType, required = false, extras = null) => {
      try {
        const params = {
          metaId,
          name,
          dataType,
          required,
        };
        if (extras) {
          params.extras = extras;
        }
        const response = await api.post("/meta/attribute", params);
        return response;
      } catch (error) {
        console.error("Error adding column:", error);
        throw error;
      }
    },
    [api]
  );

  const getDataTypeFromAttributeType = useCallback((attributeType) => {
    const typeMap = {
      text: "STRING",
      number: "INTEGER",
      date: "DATE",
      boolean: "BOOLEAN",
      "Multi Select": "MULTISELECT",
      "Single Select": "SINGLESELECT",
      phone: "PHONE",
    };
    return typeMap[attributeType] || "String";
  }, []);

  return {
    getObjectMetadata,
    updateRecordMetadata,
    addColumn,
    getDataTypeFromAttributeType,
  };
};

export default useMetaService;
